import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { PageHeader, StatusBadge } from "../components/Bits";
import { api, money, STATUSES } from "../lib/api";
import { MarketerSales } from "../components/MarketerSales";

export default function DashboardPage() {
  const [s, setS] = useState(null);
  useEffect(() => { api.get("/stats").then((r) => setS(r.data)); }, []);
  if (!s) return null;
  const cards = [
    ["Toplam Ciro", money(s.revenue), "stat-revenue", "/siparisler"],
    ["Sipariş", s.orders, "stat-orders", "/siparisler"],
    ["Ürün", s.products, "stat-products", "/urunler"],
    ["Onay Bekleyen Üye", s.pending_users, "stat-pending-users", "/kullanicilar"],
  ];
  return (
    <div>
      <PageHeader title="Yönetim Paneli" kicker={`${s.marketers} aktif plasiyer`} />
      <div className="grid grid-cols-2 gap-4 md:grid-cols-4">
        {cards.map(([k, v, id, to], i) => (
          <Link key={id} to={to} style={{ animationDelay: `${i * 60}ms` }} className={`fade-up rounded-xl border p-5 shadow-sm transition-shadow hover:shadow-md ${i === 0 ? "border-slate-950 bg-slate-950 text-white" : "border-slate-200 bg-white"}`}>
            <p className={`font-mono text-[11px] uppercase tracking-wider ${i === 0 ? "text-blue-300" : "text-slate-500"}`}>{k}</p>
            <p data-testid={id} className="mt-3 font-display text-2xl font-bold sm:text-3xl">{v}</p>
          </Link>
        ))}
      </div>
      <h2 className="mt-12 mb-4 font-display text-lg font-semibold">Sipariş Durumları</h2>
      <div className="grid grid-cols-2 gap-3 sm:grid-cols-5">
        {STATUSES.map((st) => (
          <div key={st} className="rounded-xl border border-slate-200 bg-white p-4">
            <StatusBadge status={st} />
            <p className="mt-3 font-display text-2xl font-bold" data-testid={`stat-status-${st}`}>{s.by_status[st]}</p>
          </div>
        ))}
      </div>
      <MarketerSales />
    </div>
  );
}
